import type { IconBaseProps } from "./Icon";

export default function KeyIcon({ className, color, width, height }: IconBaseProps) {
  return (
    <svg
      className={className}
      style={{ color: color }}
      width={width ?? 15}
      height={height ?? 15}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Key</title>
      <path
        d="M9.60125 6.44102L10.4262 7.26602C11.0481 7.88789 11.2669 6.74102 12.135 6.59727C12.4263 6.54852 12.6831 6.44977 12.7931 6.12727C12.8906 5.84227 12.78 5.57414 12.4344 5.22852L11.5625 4.35727M6.875 8.90039L13.125 2.65039M4.6875 13.9004C5.05684 13.9004 5.42257 13.8276 5.7638 13.6863C6.10503 13.545 6.41507 13.3378 6.67624 13.0766C6.9374 12.8155 7.14457 12.5054 7.28591 12.1642C7.42725 11.823 7.5 11.4572 7.5 11.0879C7.5 10.7185 7.42725 10.3528 7.28591 10.0116C7.14457 9.67037 6.9374 9.36032 6.67624 9.09915C6.41507 8.83799 6.10503 8.63082 5.7638 8.48948C5.42257 8.34814 5.05684 8.27539 4.6875 8.27539C3.94158 8.27539 3.22621 8.57171 2.69876 9.09915C2.17132 9.6266 1.875 10.342 1.875 11.0879C1.875 11.8338 2.17132 12.5492 2.69876 13.0766C3.22621 13.6041 3.94158 13.9004 4.6875 13.9004Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
